// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dialga: PokeData = {
  "id": 483,
  "name": "dialga",
  "height": 54,
  "weight": 6830,
  "base_experience": 306,
  "types": [
    PokeType.STEEL,
    PokeType.DRAGON
  ],
  "api_moves": [
    "slash",
    "scary-face",
    "dragon-breath",
    "iron-tail",
    "metal-claw",
    "twister",
    "ancient-power",
    "dragon-claw",
    "metal-burst",
    "heal-block",
    "aura-sphere",
    "dragon-pulse",
    "power-gem",
    "earth-power",
    "flash-cannon",
    "roar-of-time"
  ],
  "moves": [
    "scary-face",
    "dragon-breath",
    "metal-claw",
    "ancient-power",
    "dragon-claw",
    "metal-burst",
    "dragon-pulse",
    "earth-power",
    "metal-sound",
    "meteor-mash",
    "dragon-rush",
    "scrap-throw",
    "great-roar"
  ],
  "evolution_chain": {
    "id": 244,
    "item": null,
    "species": [
      {
        "name": "dialga",
        "order": 484,
        "types": [
          PokeType.STEEL,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 122,
    "speed": 104,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
